<template>
  <div class="leftclassroomArrangement">
    <div class="title-label">当前课程/会议</div>
    <div class="leftpage-content">
      <div class="swiper-containerFocus" v-if="data.length > 0">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in data" :key="index">
            <classroomArrangementItem
              :item="item"
              :isCurrent="true"
            ></classroomArrangementItem>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div v-else class="arrange-nodata">
        <div class="content">
          <img
            :src="require('_teas/public/img/product/bootScreen/img-null.png')"
            alt=""
            srcset=""
          />
          <div class="text">暂无当前课程/会议</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import classroomArrangementItem from "./classroomArrangementItem.vue";
export default {
  name: "leftclassroomArrangement",
  components: {
    classroomArrangementItem,
  },
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    data: function () {
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
  },
  created() {
    this.loadScript(() => {
      this.$nextTick(() => {
        this.initSwiper();
      });
    });
  },
  methods: {
    // 初始化swiper
    async initSwiper() {
      const _this = this;
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-containerFocus", {
          // autoplay: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination",
          },
          on: {},
        });
      });
    },
    // 加载js
    loadScript(callback) {
      this.$http
        .importFiles([
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.css"),
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.js"),
        ])
        .then(() => {
          callback?.();
        })
        .catch(() => {
          dsf.layer.message("加载fabric文件报错", false);
          reject();
        });
    },
  },
};
</script>

<style>
</style>